/**
 * Decode a base64-encoded PDF returned by the backend and trigger a browser
 * download. Mirrors the pattern in LegalAcceptanceHistoryModal so binary bytes
 * are preserved (atob → Uint8Array, NOT a plain string Blob which corrupts PDFs).
 *
 * Used by the Universal Referral Terms surfaces (TCX-810/811/739) which all
 * download the same document via `{ file, filename }` endpoints.
 */
export const downloadBase64Pdf = (file: string, filename: string): void => {
  const bytes = Uint8Array.from(atob(file), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
